import type { ReactElement } from 'react';
import { Link } from '@tanstack/react-router';
import { Icon } from '@/components/atoms/icon';
import { buttonVariants } from '@/components/atoms/button';
import { cn } from '@/lib/cn';

type Props = {
  query: string;
};

export function NoMatchesFound({ query }: Props): ReactElement {
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-6 py-10 text-center">
      <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-[var(--bg-soft)]">
        <Icon name="search" size={20} className="text-[var(--ink-3)]" />
      </div>
      <h2 className="font-display text-lg font-semibold tracking-tight text-[var(--ink)]">
        No matches in the library
      </h2>
      <p className="mt-2 max-w-xs text-sm leading-relaxed text-[var(--ink-3)]">
        Did you spell it differently? Tunes often have several names — try a fragment.
      </p>
      <div className="mt-6">
        <Link
          to="/library/contribute"
          search={{ title: query, returnTo: '/repertoire/add' }}
          className={cn(buttonVariants({ variant: 'primary', size: 'md' }))}
        >
          <Icon name="plus" size={15} />
          {`Contribute "${query}" to the catalog`}
        </Link>
      </div>
    </div>
  );
}
